import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const CredentialsFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Credentials Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the CredentialsFrame component. Replace this with your actual
          UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default CredentialsFrame;
